import { Link } from 'react-router-dom';
import './RentLease.css';
import { FaHome, FaFileContract, FaHandshake, FaCheckCircle, FaUserCheck, FaClipboardList, FaKey, FaChartLine } from 'react-icons/fa';

export default function RentLease() {
  const features = [
    {
      icon: <FaHome />,
      title: 'Property Listing',
      description: 'We list your property on major rental platforms to attract quality tenants quickly.'
    },
    {
      icon: <FaUserCheck />,
      title: 'Tenant Screening',
      description: 'Comprehensive background checks and verification to ensure reliable tenants.'
    },
    {
      icon: <FaFileContract />,
      title: 'Lease Agreement',
      description: 'Professionally drafted lease agreements that protect your interests.'
    },
    {
      icon: <FaKey />,
      title: 'Property Handover',
      description: 'Smooth handover process with complete documentation and inventory checks.'
    },
    {
      icon: <FaClipboardList />,
      title: 'Rent Collection',
      description: 'Timely rent collection and financial reporting for hassle-free income.'
    },
    {
      icon: <FaHandshake />,
      title: 'Tenant Relations',
      description: 'Professional management of tenant queries and maintenance requests.'
    },
    {
      icon: <FaChartLine />,
      title: 'Market Analysis',
      description: 'Competitive pricing strategy based on current market trends and analysis.'
    },
    {
      icon: <FaCheckCircle />,
      title: 'Legal Compliance',
      description: 'Ensuring all rental agreements comply with local laws and regulations.'
    }
  ];

  const benefits = [
    'Zero vacancy periods with our extensive tenant network',
    'Professional property photography and marketing',
    'Regular property inspections and maintenance coordination',
    'Transparent pricing with no hidden charges',
    '24/7 support for landlords and tenants',
    'Digital lease signing and documentation'
  ];

  return (
    <>
      <section className="rentlease-hero">
        <div className="rentlease-hero-content">
          <h1>Rent & Lease Services</h1>
          <p>Comprehensive rental solutions for landlords and tenants</p>
        </div>
      </section>

      <section className="rentlease-intro">
        <div className="rentlease-container">
          <div className="intro-content">
            <h2>Professional Rental Management</h2>
            <p>
              Whether you're a property owner looking to rent out your property or a tenant searching for the perfect home, 
              our rent and lease services provide end-to-end solutions. We handle everything from property marketing to 
              tenant placement, ensuring a smooth and hassle-free experience for all parties involved.
            </p>
          </div>
        </div>
      </section>

      <section className="rentlease-features">
        <div className="rentlease-container">
          <h2 className="section-title">Our Services</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rentlease-benefits">
        <div className="rentlease-container">
          <div className="benefits-wrapper">
            <div className="benefits-content">
              <h2>Why Choose Our Rental Services?</h2>
              <ul className="benefits-list">
                {benefits.map((benefit, index) => (
                  <li key={index}>
                    <FaCheckCircle className="check-icon" />
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="benefits-image">
              <img 
                src="https://images.pexels.com/photos/1370704/pexels-photo-1370704.jpeg?auto=compress&cs=tinysrgb&w=800" 
                alt="Rental Property" 
              />
            </div>
          </div>
        </div>
      </section>

      <section className="rentlease-cta">
        <div className="rentlease-container">
          <div className="cta-content">
            <h2>Ready to Rent or Lease Your Property?</h2>
            <p>Get in touch with our rental experts today for a free consultation</p>
            <Link to="/contact" className="cta-button">
              Contact Us Now
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
